// document.addEventListener("click", (event) => {
//   // console.log('test dialog', event);
//   // if (event.target && event.target.className === "rn_fileupload") {
//   //   var id = event.target.dataset.id;
//   //   var idSelector = "fileUploadDialog_" + id;
//   //
//   //   document.getElementById(idSelector).showModal()
//   //
//   // }
//
//   if (event.target && event.target.className.includes("close_dialog")) {
//     var dialog = event.target.closest('dialog')
//     dialog.close();
//   }
// })
